// src/components/MapTitle.js
import React from "react";
import { connect } from "react-redux";
import { Paper } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import TitleIcon from "@mui/icons-material/Title";
import preloaded from "../utils/data.json";

const mapStateToProps = (state) => ({
  map: state.MapReducer,
});

// túl hosszú címek rövidítése: eleje + … + vége
function shortenTitle(title, maxLen = 120) {
  if (!title) return "";
  if (title.length <= maxLen) return title;
  const head = title.slice(0, Math.floor(maxLen * 0.45));
  const tail = title.slice(-Math.floor(maxLen * 0.45));
  return `${head} … ${tail}`;
}

// metaadat keresése egy mezőnévre vagy layer ID-re
function findMetaForFieldOrLayer(fieldName, layerId) {
  if (fieldName) {
    const f = preloaded.find((o) => o.name === fieldName);
    if (f) return f;
  }
  if (layerId) {
    const short = layerId.replace("allum_project:", "");
    const f = preloaded.find((o) => o.name === short);
    if (f) return f;
  }
  return null;
}

// MAIN title: tematikus térkép valódi címe
function getMainTitle(map) {
  const activeLayer = map?.activeLayer || "";
  const activeField = map?.activeField || "";

  const isGrid =
    activeLayer.includes("grid") || activeLayer.includes("kulonb");

  if (isGrid) {
    // grid / különbség: layer meta címe
    const short = activeLayer.replace("allum_project:", "");
    const f = preloaded.find((e) => e.name === short);
    return f?.title || short || "";
  }

  // nem grid: az activeField-hez tartozó meta cím
  if (activeField) {
    const f = preloaded.find((e) => e.name === activeField);
    return f?.title || activeField || "";
  }

  return "";
}

// SECOND (②) title: tematikus cím a dualLayer meta alapján
function getDualTitle() {
  if (typeof window === "undefined") return "";
  const dl = window.__dualLayer || {};
  if (!dl.enabled) return "";

  const fieldName = dl.fieldName || null;
  const layerId = dl.layerId || null;

  const meta = findMetaForFieldOrLayer(fieldName, layerId);
  if (meta && meta.title) return meta.title;

  if (layerId) {
    const short = layerId.replace("allum_project:", "");
    return short;
  }
  if (fieldName) return fieldName;

  return "";
}

const MapTitle = (props) => {
  const [showPanel, setShowPanel] = React.useState(true);
  // re-render, ha a ② változik
  const [, setDualTick] = React.useState(0);

  React.useEffect(() => {
    const onDual = () => setDualTick((t) => t + 1);
    if (typeof window !== "undefined") {
      window.addEventListener("dualLayerChanged", onDual);
      return () => window.removeEventListener("dualLayerChanged", onDual);
    }
  }, []);

  const mainTitleRaw = getMainTitle(props.map);
  const dualTitleRaw = getDualTitle();

  const mainTitle = shortenTitle(mainTitleRaw);
  const dualTitle = shortenTitle(dualTitleRaw);
  const hasDual = Boolean(dualTitle);

  return (
    <div>
      {!showPanel ? (
        <Tooltip title="Show map title">
        <IconButton
          style={{ color: "gray" }}
          onClick={() => {
            setShowPanel(true);
          }}
          aria-label="show-title"
        >
          <TitleIcon />
        </IconButton>
        </Tooltip>
      ) : (
        ""
      )}

      <Paper
        elevation={0}
        style={{
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          padding: 10,
          marginRight: 40,
          minWidth: 150,
          display: showPanel ? "block" : "none",
          paddingLeft: 16,
          maxWidth: "calc(100vh - 150px)",
          maxHeight: "calc(100vh - 90px)",
          overflowY: "auto",
          borderRadius: 10,
          backgroundColor: "rgba(255, 255, 255, 0.75)",
        }}
        onClick={() => {
          setShowPanel(false);
        }}
      >
        <span>
          {hasDual ? (
            <>① {mainTitle} + ② {dualTitle}</>
          ) : (
            <>{mainTitle}</>
          )}
        </span>
      </Paper>
    </div>
  );
};

export default connect(mapStateToProps)(MapTitle);
